import React from 'react';
import { styles } from './CollapsedContentBlock.css';
import { Pencil } from '@jbhi-fi/lanyard-ui/components/Icons';
import { JBButton } from '@jbhi-fi/lanyard-ui';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';

export type CollapsedContentBlockProps = {
  onClick?: () => void;
  title: string;
  status: 'added' | 'cancelled';
  price: string;
};

export const CollapsedContentBlock = ({ title, status, price, onClick }: CollapsedContentBlockProps) => {
  return (
    <div className={styles.wrapperContainer}>
      <div className={styles.headingContainer}>
        <CalloutFont className={styles.heading} as="h3">
          {title}
        </CalloutFont>
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.stackContent}>
          {status === 'added' ? (
            <>
              <p className={styles.greenText}>Added</p> <p>{price}</p>
            </>
          ) : (
            <p className={styles.greyText}>Not added</p>
          )}
        </div>
        {onClick && status === 'cancelled' ? (
          <JBButton type="iconOnly" icon={<Pencil />} aria-label="Edit" onClick={onClick} />
        ) : null}
      </div>
    </div>
  );
};
